import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Profile } from "../../Components";
import { arrowLeft, Toast } from "../../Components";
import AssetsAdd from "./AssetsAdd";
import AssetsDeleted from "./AssetsDeleted";
import AssetsEdit from "./AssetsEdit";
import AssetsMain from "./AssetsMain";
import ModalAssetDetail from "./ModalAssetDetail";
import ModalAssetFull from "./ModalAssetFull";
import ModalAssetPermanent from "./ModalAssetPermanent";
import { contentService } from "../../Services";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { storageHandler } from "../../Helpers/storage";
import { parseInput } from "../../Components/Constants/AppConstant";

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="error-fallback"
          style={{
            padding: "20px",
            textAlign: "center",
            color: "#721c24",
            backgroundColor: "#f8d7da",
          }}
        >
          <h3>Something went wrong.</h3>
          <details
            style={{
              whiteSpace: "pre-wrap",
              textAlign: "left",
              margin: "10px 0",
            }}
          >
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
          <button
            onClick={() =>
              this.setState({ hasError: false, error: null, errorInfo: null })
            }
            style={{
              padding: "8px 16px",
              marginTop: "10px",
              cursor: "pointer",
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function Assets({
  cartItem,
  closeCartPanel,
  setAuth,
  setModal,
  user,
  NotifModul,
  profiles,
  setModalNotification,
  locationData,
  goToPricing,
}) {
  const [tab, setTab] = useState("main");
  const [modalAsset, setModalAsset] = useState(null);
  const [modalDataAsset, setModalDataAsset] = useState(null);
  const [editTabData, setEditTabData] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const [toastList, setToastList] = useState([]);
  const [assestsList, setAssestsList] = useState({ campaigns: [] });
  const [rowCount, setRowCount] = useState([]);
  const [selectDesc, setselectDesc] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchList, setSearchList] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (modalAsset) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modalAsset]);

  useEffect(() => {
    setTab("main");
    setPage(1);
    setSearchText("");
    setselectDesc("");
  }, [locationData.key]);

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoaded(false);
        setError(null);
        const filterBy = tab !== "deleted" ? "active" : "inactive";
        let filterString = `filter[asset.status]=` + filterBy;
        if (searchText != "" && selectDesc != "") {
          filterString += "&filter[" + selectDesc + "]=" + searchText;
        }

        const res = await contentService.getAll({
          page: page,
          pageSize,
          filter: filterString,
        });

        if (res.meta && res.meta.pagination) {
          setPaginationData(res.meta.pagination);
        }
        setRowCount(res.data.length);
        setAssestsList(res.data);
        setIsLoaded(true);
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg: error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoaded(true);
        }
      }
    }
    fetchData();
  }, [page, tab, rowCount, searchList]);

  const onPaginate = (page) => {
    try {
      setPage(page);
    } catch (err) {
      setError("Failed to change page.");
      console.error("Paginate error:", err);
    }
  };

  const changeMediumDesc = (item) => {
    try {
      setselectDesc(item.id);
      setPage(1);
      setSearchText("");
      setSearchList(!searchList);
    } catch (err) {
      setError("Failed to change filter.");
      console.error("Filter change error:", err);
    }
  };

  const setSearchTextOnChange = (event) => {
    try {
      if (event.target.value === "") {
        setSearchList(!searchList);
        setselectDesc("");
      }
      setSearchText(event.target.value);
    } catch (err) {
      setError("Failed to update search.");
      console.error("Search change error:", err);
    }
  };

  const search = () => {
    try {
      setSearchList(!searchList);
      setPage(1);
    } catch (err) {
      setError("Search failed.");
      console.error("Search error:", err);
    }
  };

  const addToast = (data) => {
    try {
      const newToastList = [...toastList];
      newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
      setToastList(newToastList);
    } catch (err) {
      console.error("Toast error:", err);
    }
  };

  const deleteAssetPermanently = async () => {
    try {
      if (modalDataAsset.id) {
        const deleteID = modalDataAsset.id;
        const res = await contentService.permanentdelete(deleteID);
        if (res.status === "failed") {
          addToast({
            error: true,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        if (res.status !== "failed") {
          addToast({
            error: false,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        setRowCount(rowCount - 1);
        setModalAsset(null);
      }
    } catch (err) {
      setError("Failed to delete asset permanently.");
      console.error("Delete permanent error:", err);
      addToast({
        error: true,
        msg: err.message || "Failed to delete asset",
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  const recoverAsset = async () => {
    try {
      if (modalDataAsset.id) {
        const deleteID = modalDataAsset.id;
        const res = await contentService.delete(deleteID, {
          status: "active",
        });

        if (res.status === "failed") {
          addToast({
            error: true,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        if (res.status !== "failed") {
          addToast({
            error: false,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        setRowCount(rowCount - 1);
        setModalAsset(null);
      }
    } catch (err) {
      setError("Failed to recover asset.");
      console.error("Recover error:", err);
      addToast({
        error: true,
        msg: err.message || "Failed to recover asset",
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  const deleteAsset = async () => {
    try {
      if (modalDataAsset.id) {
        const deleteID = modalDataAsset.id;
        const res = await contentService.delete(deleteID, {
          status: "inactive",
        });

        if (res.status === "failed") {
          addToast({
            error: true,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        if (res.status !== "failed") {
          addToast({
            error: false,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        setRowCount(rowCount - 1);
        setModalAsset(null);
      }
    } catch (err) {
      setError("Failed to delete asset.");
      console.error("Delete error:", err);
      addToast({
        error: true,
        msg: err.message || "Failed to delete asset",
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  const handleTabChange = (newTab) => {
    try {
      setTab(newTab);
      onPaginate(1);
      setAssestsList([]);
    } catch (err) {
      setError("Failed to change tab.");
      console.error("Tab change error:", err);
    }
  };

  const handleModalClose = () => {
    try {
      setModalAsset(null);
    } catch (err) {
      setError("Failed to close modal.");
      console.error("Modal close error:", err);
    }
  };

  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }
  useEffect(() => {
    data.p_f_ids.includes(17);
  }, []);

  return (
    <>
      {data.p_f_ids.includes(17) ? (
        <>
          <div className="main">
            <div className="main__inner">
              <div className="main__inner-title">
                {tab === "main" ? (
                  ""
                ) : (
                  <div className="main__inner-title-col">
                    {tab === "deleted" ? (
                      <h2>Deleted assets</h2>
                    ) : (
                      <h2>Assets</h2>
                    )}
                    <button
                      className="button tertiary big"
                      onClick={() => {
                        setTab("main");
                        onPaginate(1);
                        setAssestsList([]);
                      }}
                    >
                      {arrowLeft} Back to asset list
                    </button>
                  </div>
                )}
              </div>

              <ErrorBoundary>
                {tab === "main" && (
                  <AssetsMain
                    setTab={setTab}
                    assestsList={assestsList}
                    setModalAsset={setModalAsset}
                    setModalDataAsset={setModalDataAsset}
                    paginationData={paginationData}
                    onPaginate={onPaginate}
                    isLoaded={isLoaded}
                    campaignsUsing={assestsList.campaigns}
                    setAssestsList={setAssestsList}
                    changeMediumDesc={changeMediumDesc}
                    setSearchTextOnChange={setSearchTextOnChange}
                    search={search}
                    searchText={searchText}
                    selectDesc={selectDesc}
                  />
                )}
              </ErrorBoundary>

              <ErrorBoundary>
                {tab === "deleted" && (
                  <AssetsDeleted
                    setModalAsset={setModalAsset}
                    setModalDataAsset={setModalDataAsset}
                    assestsList={assestsList}
                    paginationData={paginationData}
                    onPaginate={onPaginate}
                    isLoaded={isLoaded}
                    campaignsUsing={assestsList.campaigns}
                  />
                )}
              </ErrorBoundary>

              <ErrorBoundary>
                {tab === "add" && (
                  <AssetsAdd
                    setTab={setTab}
                    setToastList={setToastList}
                    toastList={toastList}
                  />
                )}
              </ErrorBoundary>

              <ErrorBoundary>
                {tab === "edit" && (
                  <AssetsEdit
                    {...editTabData}
                    setTab={setTab}
                    setToastList={setToastList}
                    toastList={toastList}
                  />
                )}
              </ErrorBoundary>
            </div>
          </div>

          <AnimatePresence>
            <ErrorBoundary>
              {modalAsset === "detail" && (
                <ModalAssetDetail
                  close={handleModalClose}
                  deleteAsset={deleteAsset}
                  {...modalDataAsset}
                  mediaClick={() => setModalAsset("full")}
                  editBtnClick={() => {
                    setEditTabData(modalDataAsset);
                    setTab("edit");
                    setModalAsset(null);
                  }}
                  campaignsUsing={modalDataAsset.campaigns}
                />
              )}
            </ErrorBoundary>

            <ErrorBoundary>
              {modalAsset === "permanent" && (
                <ModalAssetPermanent
                  close={handleModalClose}
                  {...modalDataAsset}
                  mediaClick={() => setModalAsset("fullPermanent")}
                  recoverAsset={recoverAsset}
                  deleteAssetPermanently={deleteAssetPermanently}
                />
              )}
            </ErrorBoundary>

            <ErrorBoundary>
              {(modalAsset === "full" || modalAsset === "fullPermanent") && (
                <ModalAssetFull
                  backClick={() => {
                    if (modalAsset === "full") setModalAsset("detail");
                    else if (modalAsset === "fullPermanent")
                      setModalAsset("permanent");
                  }}
                  modalAsset={modalAsset}
                  close={handleModalClose}
                  {...modalDataAsset}
                  setModalAsset={setModalAsset}
                />
              )}
            </ErrorBoundary>
          </AnimatePresence>

          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      ) : (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Assets"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
}
